$(document).ready(function () {
    if($('.b-page__main .b-navigator-blocker').length) {
        var pageHeight = $('.b-page__main').height();
 
        $('.b-page__main').css('height', `${pageHeight*0.75}px`).addClass('is-content-block');
        $('.b-page__main .b-navigator-blocker').show();
    }
 });